export default __webpack_public_path__ + "dadea5f740a58a0f63565f1295854a98.gif";